<template>
  <b-button
    v-if="!$store.state.isLoggedIn && !$store.state.isLoginProcessing"
    class="has-text-weight-bold is-info"
    :size="size"
    @click="signUp(redirect_uri)"
    rounded
    v-html="$t('signup_button')"
  />
</template>

<script>
export default {
  name: "ButtonSignUp",
  props: {
    redirect_uri: {
      type: String,
      default: '/dashboard'
    },
    size: {
      type: String,
      default: '' // '', 'is-small', 'is-medium', 'is-large'
    }
  }
}
</script>

<style lang="scss" scoped></style>
